const Faculty = () => {
    return (
        <div id="faculty" className="vision-card">

            <h3 className="table-section-heading">
                FACULTY & STAFFS
            </h3>

            <div className="table-section-wrap">
                <table className="table-section faculty-table">
                    <tbody>

                        <tr>
                            <td>TOTAL NUMBER OF TEACHERS (ALL CLASSES)</td>
                            <td>59</td>
                            <td>NUMBER OF PGT s</td>
                            <td>22</td>
                        </tr>

                        <tr>
                            <td>NUMBER OF TGT s</td>
                            <td>18</td>
                            <td>NUMBER OF PRT s</td>
                            <td>19</td>
                        </tr>

                        <tr>
                            <td>NUMBER OF PET s</td>
                            <td>2</td>
                            <td>OTHER NON-TEACHING STAFF</td>
                            <td>2</td>
                        </tr>

                        <tr>
                            <td>NUMBER OF MANDATORY TRAINING QUALIFIED TEACHERS</td>
                            <td>59</td>
                            <td>NUMBER OF TRAININGS ATTENDED BY FACUL TY SINCE LAST YEAR</td>
                            <td>4</td>
                        </tr>

                    </tbody>
                </table>

            </div>

            <div className="table-section-wrap">
                <h2 className="pta-title">
                    Teacher
                </h2>

                <table className="table-section">
                    <thead>
                        <tr>
                            <th>SL NO</th>
                            <th>TEACHER NAME</th>
                            <th>DESIGNATION</th>
                            <th>QUALIFICATION</th>
                        </tr>
                    </thead>

                    <tbody>

                        <tr className="teacher-group">
                            <td colSpan="4">PGT Teacher</td>
                        </tr>

                        <tr><td>1</td><td>SHAJI LOISE</td><td>PGT PRINCIPAL</td><td>M.A, B.Ed</td></tr>
                        <tr><td>2</td><td>JITENDRA KUMAR YADAV</td><td>PGT</td><td>M.Sc, B.Ed</td></tr>
                        <tr><td>3</td><td>AKASH CHAUBEY</td><td>PGT</td><td>M.Sc, B.Ed</td></tr>
                        <tr><td>4</td><td>Amit Kumar Kanaujia</td><td>PGT</td><td>M.Sc, B.Ed</td></tr>
                        <tr><td>5</td><td>Nidhi Singh</td><td>PGT</td><td>M.P.Ed</td></tr>
                        <tr><td>6</td><td>AJEET KUMAR PANDEY</td><td>PGT</td><td>M.A, B.Ed, NET</td></tr>
                        <tr><td>7</td><td>MAHESH AGRAHARI</td><td>PGT</td><td>M.Com, B.Ed</td></tr>
                        <tr><td>8</td><td>SHIV KUMAR TRIPATHI</td><td>PGT</td><td>M.A, B.Ed</td></tr>
                        <tr><td>9</td><td>DHANANJAY CHAUBEY</td><td>PGT</td><td>M.Com, B.Ed</td></tr>
                        <tr><td>10</td><td>SATYENDRA NATH PANDEY</td><td>PGT</td><td>B.Sc, MCA</td></tr>
                        <tr><td>11</td><td>DIWAKER</td><td>PGT</td><td>M.Sc, B.Ed</td></tr>
                        <tr><td>12</td><td>RAMESH CHAND YADAV</td><td>PGT</td><td>M.A, B.Ed</td></tr>
                        <tr><td>13</td><td>SHRI KRISHNA MISHRA</td><td>PGT</td><td>M.Sc, B.Ed</td></tr>
                        <tr><td>14</td><td>ASHWANI SHARMA</td><td>PGT</td><td>M.A, B.Ed</td></tr>
                        <tr><td>15</td><td>PRADEEP KUMAR PANDEY</td><td>PGT</td><td>M.A, B.Ed</td></tr>
                        <tr><td>16</td><td>NAVEEN KUMAR PATHAK</td><td>PGT</td><td>M.Sc, B.Ed</td></tr>
                        <tr><td>17</td><td>ABHISHEK TRIPATHI</td><td>PGT</td><td>M.Sc, B.Ed</td></tr>
                        <tr><td>18</td><td>ABDUL BASITH K</td><td>PGT</td><td>M.A, B.Ed</td></tr>
                        <tr><td>19</td><td>SUNIL PAIK</td><td>PGT</td><td>M.A, B.Ed</td></tr>
                        <tr><td>20</td><td>DURGESH PATHAK</td><td>PGT</td><td>M.Sc (Biotech), B.Ed</td></tr>
                        <tr><td>21</td><td>PRADEEP KUMAR</td><td>PGT</td><td>M.Sc, B.Ed</td></tr>
                        <tr><td>22</td><td>ANIRUDH YADAV</td><td>PGT</td><td>M.Sc (Maths), B.Ed</td></tr>

                        <tr className="teacher-group">
                            <td colSpan="4">TGT Teacher</td>
                        </tr>

                        <tr><td>23</td><td>SHERLY</td><td>TGT</td><td>B.A, B.Ed</td></tr>
                        <tr><td>24</td><td>SONIYA SHARMA</td><td>TGT</td><td>M.A, B.Ed</td></tr>
                        <tr><td>25</td><td>MANOJ GUPTA</td><td>TGT</td><td>B.Tech (IT)</td></tr>
                        <tr><td>26</td><td>MANISH KUMAR SINGH</td><td>TGT</td><td>B.A, B.P.Ed</td></tr>
                        <tr><td>27</td><td>POONAM GUPTA</td><td>TGT</td><td>B.Sc, B.Ed</td></tr>
                        <tr><td>28</td><td>Pradeep Kumar Srivastava</td><td>TGT</td><td>B.A, B.Ed</td></tr>
                        <tr><td>29</td><td>NISHA RAI</td><td>TGT</td><td>M.A, B.Ed</td></tr>
                        <tr><td>30</td><td>BAIBHAV TRIPATHI</td><td>TGT</td><td>M.A, D.El.Ed</td></tr>
                        <tr><td>31</td><td>RANI CHATURVEDI</td><td>TGT</td><td>M.Sc, D.El.Ed</td></tr>
                        <tr><td>32</td><td>PRAGYA SRIVASTAVA</td><td>TGT</td><td>M.A, B.Ed</td></tr>
                        <tr><td>33</td><td>KRISHNA KUMAR GUPTA</td><td>TGT</td><td>M.A, B.Ed</td></tr>
                        <tr><td>34</td><td>POONAM GUPTA -2</td><td>TGT</td><td>M.A, B.Ed</td></tr>
                        <tr><td>35</td><td>SANTOSH KUMAR YADAV</td><td>TGT</td><td>M.Sc, C.B.Ed</td></tr>
                        <tr><td>36</td><td>DURGESH MANI TRIPATHI</td><td>TGT</td><td>M.A, B.Ed</td></tr>
                        <tr><td>37</td><td>BABITA PANDEY</td><td>TGT</td><td>M.A, B.Ed</td></tr>
                        <tr><td>38</td><td>SATISH SAHANI</td><td>TGT</td><td>PGDCA (B.A)</td></tr>
                        <tr><td>39</td><td>PRASHANT PANDEY</td><td>TGT</td><td>B.Sc, B.Ed</td></tr>
                        <tr><td>40</td><td>PRADUMN SHARMA</td><td>TGT</td><td>MA BEd</td></tr>

                        <tr className="teacher-group">
                            <td colSpan="4">PRT Teacher</td>
                        </tr>

                        <tr><td>41</td><td>MAMTA KANOLIA</td><td>PRT</td><td>B.Com, D.El.Ed</td></tr>
                        <tr><td>42</td><td>AISHVARYA PANDEY</td><td>PRT</td><td>M.Sc, B.Ed</td></tr>
                        <tr><td>43</td><td>PREM PRAKASH BHARTI</td><td>PRT</td><td>M.A, D.El.Ed</td></tr>
                        <tr><td>44</td><td>MAMTA CHAUDHARY</td><td>PRT</td><td>M.A, B.Ed</td></tr>
                        <tr><td>45</td><td>VANDANA P SHRIVASTAVA</td><td>PRT</td><td>M.A, B.Ed</td></tr>
                        <tr><td>46</td><td>KM MANISHA GUPTA</td><td>PRT</td><td>M.A, B.Ed</td></tr>
                        <tr><td>47</td><td>ANITA AGRAHARI</td><td>PRT</td><td>M.A</td></tr>
                        <tr><td>48</td><td>Lakshmi Sharma</td><td>PRT</td><td>B.A, B.Ed</td></tr>
                        <tr><td>49</td><td>MAHIMA JAISWAL</td><td>PRT</td><td>B.Tech, B.Ed</td></tr>
                        <tr><td>50</td><td>NISHA DUBEY</td><td>PRT</td><td>M.A, B.Ed</td></tr>
                        <tr><td>51</td><td>Annapurna Srivastava</td><td>PRT</td><td>M.A, B.Ed</td></tr>
                        <tr><td>52</td><td>PRIYA AGRAHARI</td><td>PRT</td><td>M.Sc, B.Ed</td></tr>
                        <tr><td>53</td><td>SAKSHEE VIMAL</td><td>PRT</td><td>B.Com, BTC</td></tr>
                        <tr><td>54</td><td>DAYASHANKAR</td><td>PRT</td><td>M.Sc, B.Ed</td></tr>
                        <tr><td>55</td><td>PREM PRAKASH BHARTI</td><td>PRT</td><td>M.A, D.El.Ed</td></tr>
                        <tr><td>56</td><td>SNEHA MADHRESHIYA</td><td>PRT</td><td>M.A, B.Ed</td></tr>
                        <tr><td>57</td><td>AMITRAJ CHAURASYA</td><td>PRT</td><td>M.A, B.Ed</td></tr>
                        <tr><td>58</td><td>SUMITRA YADAV</td><td>PRT</td><td>B.A, B.Ed</td></tr>
                        <tr><td>59</td><td>NISHA SATYARTHI</td><td>Music Teacher</td><td>M.A, B.Ed</td></tr>

                    </tbody>
                </table>
            </div>

        </div >

    );
};

export default Faculty;